export default __webpack_public_path__ + "static/media/underground-lab.c1dae926.jpg";